import { userSettingsSchema } from '../../../shared/source/data-contract/user-settings-schema';

import type { UserSettingsPayload } from './user-settings';
import type { UserSettings } from '../../../shared/source/data-contract/user-settings-schema';
import type { ValidatingHttpFetcherWithBaseUrl } from '../../../shared/source/validating-http-fetcher';
import type Result from 'true-myth/result';

export type UpdateUserSettings = (userSettings: UserSettingsPayload) => Promise<Result<UserSettings, unknown>>;

export const createUpdateUserSettings = (dependencies: {
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
}): UpdateUserSettings => {
    const { validatingCobrainerApiFetcher } = dependencies;

    return (userSettings) => {
        return validatingCobrainerApiFetcher.patchJson(userSettingsSchema, {
            pathname: `/users/me/settings`,
            payload: userSettings,
        });
    };
};
